import React, { FC, useState, useEffect } from "react";

import { Table, Row, Col, Button, Input, Typography, Tag } from "antd";

import { PlusCircleOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/lib/table";
import { PagedResult } from "states/paged-result-model";
import { useDebouncedCallback } from "use-debounce/lib";

import {
  RemovedStaffModel,
  SearchStaffRequestModel,
  StaffModel,
} from "states/staff/staff.models";
import { searchStaff } from "states/staff/staff.api";
import { StaffModalComponent } from "./staff-modal";
import { t, CoreResource } from "shared/plugins/localization";
import {
  Email,
  IsActive,
  Name,
  Phone,
  StaffText,
} from "shared/constants/define-localization";
import { useDispatch } from "react-redux";
import { fetchBranchList } from "states/branch/branch.slice";
import { StaffQrModalComponent } from "./staff-qr-modal";
interface IGetQrModal {
  userId: string;
  toggleModal: boolean;
}
interface IStaffProps {}
const Staff: FC<IStaffProps> = () => {
  const dispatch = useDispatch();
  const [selectedRowsKeys, setSelectedRowsKeys] = useState<RemovedStaffModel>({
    idList: [],
  });
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [pagedResults, setPagedResults] = useState(
    {} as PagedResult<StaffModel>
  );
  const [isModal, setModal] = useState(false);
  const [isUpdate, setUpdate] = useState(false);
  const [model, setModel] = useState<StaffModel>({} as StaffModel);
  const [qrModal, setQrModal] = useState<IGetQrModal>({} as IGetQrModal);
  const [filterModel, setFilterModel] = useState<SearchStaffRequestModel>({
    page: 1,
    pageSize: 20,
  });

  const rowSelection = {
    selectedRowsKeys,
    onChange: (selectedRowKeys: any) => {
      setSelectedRowsKeys({ ...selectedRowsKeys, idList: selectedRowKeys });
    },
  };

  const onEmptySelection = () => {
    setSelectedRowsKeys({ ...selectedRowsKeys, idList: [] });
  };

  const handleCloseModal = () => {
    setModal(false);
  };
  const handleAddStaff = () => {
    setModel({} as StaffModel);
    setModal(true);
    setUpdate(false);
  };
  const gotoPage = async (page: number) => {
    setIsLoadingList(true);
    const result = await searchStaff({ ...filterModel, page });
    result.data.results.forEach((m) => (m.key = m.id.toString()));
    setPagedResults(result.data);
    setIsLoadingList(false);
  };
  const handleSearch = useDebouncedCallback(() => {
    gotoPage(1);
  }, 500);

  const columns: ColumnsType<StaffModel> = [
    {
      title: "Tên",
      dataIndex: "firstName",
      key: "firstName",
      render: (firstName: string, item) => (
        <React.Fragment>
          <Button
            type="text"
            onClick={() => {
              setModel(item);
              setModal(true);
              setUpdate(true);
            }}
          >
            {item.lastName} {firstName}
          </Button>
        </React.Fragment>
      ),
    },
    {
      title: "Địa chỉ email",
      dataIndex: "email",
      key: "email",
      render: (email: string) => <Typography.Text>{email}</Typography.Text>,
    },
    {
      title: "Số điện thoại",
      dataIndex: "phone",
      key: "phone",
      render: (phone: string) => <Typography.Text>{phone}</Typography.Text>,
    },
    {
      title: t(CoreResource, IsActive),
      dataIndex: "active",
      key: "active",
      render: (active: boolean) => (
        <>
          {active ? (
            <Tag color="#87d068">Active</Tag>
          ) : (
            <Tag color="#f50">InActive</Tag>
          )}
        </>
      ),
    },
    {
      title: "QR Code",
      dataIndex: "userProfileId",
      key: "userProfileId",
      render: (userProfileId: string, item: StaffModel) => (
        <>
          {
            <Button
              type="primary"
              onClick={() => {
                setQrModal({
                  ...qrModal,
                  toggleModal: true,
                  userId: userProfileId,
                });
              }}
            >
              Get QR Code
            </Button>
          }
        </>
      ),
    },
  ];

  useEffect(() => {
    handleSearch();
  }, [filterModel]);

  useEffect(() => {
    document.title = t(CoreResource, StaffText);
    dispatch(fetchBranchList());
  }, []);

  return (
    <div className="staff">
      <Row gutter={[16, 16]} justify="space-between" className="mb-4">
        <Col span={6}>
          <Input.Search
            value={filterModel.keyword}
            placeholder={"Tìm kiếm..."}
            onChange={(e) => {
              setFilterModel({ ...filterModel, keyword: e.target.value });
            }}
          ></Input.Search>
        </Col>

        <Col span={6} className="d-flex justify-content-end">
          <Button
            type="primary"
            onClick={handleAddStaff}
            icon={<PlusCircleOutlined />}
          >
            Thêm nhân viên
          </Button>
        </Col>
      </Row>
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={pagedResults.results}
        size="small"
        pagination={{
          total: pagedResults.totalItemCount,
          pageSize: pagedResults.pageSize,
          current: pagedResults.currentPage,
          onChange: gotoPage,
        }}
        loading={isLoadingList}
      ></Table>

      <StaffModalComponent
        model={model}
        onModal={isModal}
        closeModal={handleCloseModal}
        onSuccess={handleSearch}
        isUpdate={isUpdate}
      />
      <StaffQrModalComponent
        userId={qrModal?.userId}
        onModal={qrModal?.toggleModal}
        closeModal={() => {
          setQrModal({ ...qrModal, userId: "", toggleModal: false });
        }}
      />
    </div>
  );
};

export default Staff;
